/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Aiflowphotoposition3Inputs */

const en_aiflowphotoposition3 = /** @type {(inputs: Aiflowphotoposition3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Position`)
};

const de_aiflowphotoposition3 = /** @type {(inputs: Aiflowphotoposition3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Position`)
};

/**
* | output |
* | --- |
* | "Position" |
*
* @param {Aiflowphotoposition3Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const aiflowphotoposition3 = /** @type {((inputs?: Aiflowphotoposition3Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Aiflowphotoposition3Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_aiflowphotoposition3(inputs)
	return de_aiflowphotoposition3(inputs)
});
export { aiflowphotoposition3 as "aiFlowPhotoPosition" }